var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFileAttachment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 36,
    viewBox: "0 0 27 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.5 11.5v22.07a2 2 0 002 1.93h18a2 2 0 002-1.9v-2.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5 6.5h3a2.06 2.06 0 012 2v21a2.06 2.06 0 01-2 2h-18a2.06 2.06 0 01-2-2v-21a2.06 2.06 0 012-2h10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5 19.5v-14a5.18 5.18 0 00-5-5 5.18 5.18 0 00-5 5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5 19.62a2.8 2.8 0 01-3 2.88 2.8 2.8 0 01-3-2.88V10.5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileAttachment);
export default __webpack_public_path__ + "static/media/file-attachment.5acd136a86f9735a30772c5d485ead03.svg";
export { ForwardRef as ReactComponent };